var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
var TogglesContext = createContext(null);
export var TogglesProvider = function (props) {
    var _a = useState({}), toggles = _a[0], setToggles = _a[1];
    var _b = useState({}), showRequired = _b[0], setShowRequired = _b[1];
    var allChecked = (props.requiredToggles || []).every(function (toggle) { return toggles[toggle.id]; });
    var setToggle = function (id, value) {
        setShowRequired(function (r) {
            var _a;
            return (__assign(__assign({}, r), (_a = {}, _a[id] = !value, _a)));
        });
        setToggles(function (t) {
            var _a;
            return (__assign(__assign({}, t), (_a = {}, _a[id] = value, _a)));
        });
    };
    var showRequiredErrors = function () {
        var required = {};
        for (var _i = 0, _a = props.requiredToggles || []; _i < _a.length; _i++) {
            var toggle = _a[_i];
            if (!toggles[toggle.id]) {
                required[toggle.id] = true;
            }
        }
        setShowRequired(required);
    };
    return (_jsx(TogglesContext.Provider, __assign({ value: {
            toggles: toggles,
            setToggle: setToggle,
            allChecked: allChecked,
            showRequired: showRequired,
            showRequiredErrors: showRequiredErrors,
            requiredToggles: props.requiredToggles,
        } }, { children: props.children })));
};
export var useToggles = function () {
    var context = useContext(TogglesContext);
    if (!context)
        throw new Error('TogglesProvider not found in root');
    return context;
};
//# sourceMappingURL=Toggles.js.map